import { gql } from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';

import { GetWaypoint, GetWaypointVariables } from '@generated/graphql';
import { ImageFragments } from '@graphql/fragments/rutilus/ImageType';
import { UserFragments } from '@graphql/fragments/rutilus/UserType';

export const getWaypoint: TypedDocumentNode<GetWaypoint, GetWaypointVariables> = gql`
  query GetWaypoint($id: ID!) {
    waypoint(id: $id) {
      _id: externalId
      lat
      lng
      name
      description
      symbol
      image(croppingStrategy: CENTER, width: 400, format: WEBP) {
        ...ImageFields
      }
      user {
        nickname
        ...UserId
        ...UserAvatar
      }
    }
  }
  ${UserFragments.id}
  ${UserFragments.avatar}
  ${ImageFragments.imageFields}
`;
